
(() => {
  function initTeamsMenu(root) {
    if (!root || root.dataset.teamsMenuInitialized === 'true') return;

    const searchInput = root.querySelector(
      '[data-team-search], [data-teams-mobile-search]'
    );

    const grid = root.querySelector(
      '[data-team-grid], [data-teams-mobile-grid]'
    );

    if (!searchInput || !grid) return;

    const items = Array.from(
      grid.querySelectorAll(
        '[data-team-search-item], [data-teams-mobile-item]'
      )
    );

    const emptyState = root.querySelector(
      '[data-team-search-empty], [data-teams-mobile-empty]'
    );

    const emptyMessage = emptyState?.querySelector('strong');
    const emptyTemplate = emptyState?.dataset.noResultsTemplate || '';

    root.dataset.teamsMenuInitialized = 'true';

    function filterTeams() {
      const query = searchInput.value.trim().toLocaleLowerCase();
      let visibleCount = 0;

      items.forEach((item) => {
        const name = (
          item.dataset.teamName || item.textContent || ''
        ).trim().toLocaleLowerCase();

        const matches = name.includes(query);

        item.hidden = !matches;

        if (matches) visibleCount++;
      });

      if (emptyState) {
        emptyState.hidden = visibleCount > 0;
      
        if (emptyMessage) {
          emptyMessage.textContent = emptyTemplate
            .replace(/\{\{\s*current_tab\s*\}\}/g, '')
            .replace(/\{\{\s*query\s*\}\}/g, searchInput.value.trim());
        }
      }
    }

    searchInput.addEventListener('input', filterTeams);

    filterTeams();
  }

  function initAllTeamsMenus() {
    document.querySelectorAll(
      '[data-teams-menu], [data-teams-mobile]'
    ).forEach(initTeamsMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllTeamsMenus);
  } else {
    initAllTeamsMenus();
  }
})();
